@use "../../styles/layout.module.scss" as l;
@use "../../styles/breakpoint.module.scss" as *;

.controls {
    display: flex;
    grid-column: content;
    justify-content: end;
    gap: 7px;

    > :first-child {
        transform: rotate(180deg);
    }

    @media ($below-mobile) {
        display: none;
    }
}

.hiddenControls {
    composes: controls;
    display: none;
}

.carousel {
    composes: repeater from "../../styles/layout.module.scss";
    row-gap: var(--spacer-24);
}

.numbered {
    composes: carousel;
    counter-reset: level1;

    [aria-roledescription="slide"] {
        counter-increment: level1;
    }

    .headline::before {
        content: counter(level1) ". ";
        color: var(--red);
        padding-right: var(--spacer-16);
        float: left;
        font: var(--font-hb-104);
    }
}

.scroller {
    grid-column: 1 / -1;
    scrollbar-width: none;
    grid-row: 1;
    scroll-padding-inline: var(--spacer-margin);

    > * {
        display: flex;
        flex-wrap: nowrap;
        gap: var(--spacer-gutter);
        padding-inline-start: var(--spacer-margin);
        padding-bottom: 5px;

        // Browsers ignore padding-inline-end on overflowing flex containers,
        // so use an ::after flex item to force the right margin to be scrollable.
        &::after {
            content: "";
            flex: 0 0 var(--spacer-margin);
            margin-inline-start: calc(-1 * var(--spacer-gutter));
        }

        // slide
        > * {
            flex: 0 0 l.span(4);

            @media ($below-tablet) {
                flex-basis: l.span(6);
            }

            @media ($below-mobile) {
                flex-basis: l.span(5);
            }
        }
    }
}

.card {
    picture {
        margin-bottom: var(--spacer-24);
        display: block;
        max-width: 100%;
    }

    :global(.imageDataWrapper) {
        max-width: 100%;
        overflow: hidden;
    }

    :global(.imageDataWrapper) svg {
        width: 100%;
        height: auto;
    }

    a {
        margin-top: var(--spacer-24);
    }
}

.headline {
    composes: fontHB48 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-16);
    display: flex;
    align-items: center;
}
